// https://javascriptf1.com/snippet/convert-string-to-pascal-case-in-javascript

export const getStringAsPascalCase = (string: string) =>
  ` ${string}`.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
